import styled from '@emotion/styled'

export const StyledFeesBox = styled.div`
  width: auto;
`

export type Mutation<T> = (item: T) => void
